module.exports = __webpack_public_path__ + "static/media/Cityscape.ceffaa46.jpg";